export const theme = {
  // ************* Fonts ************* //
  typography: {
    family: 'Helvetica Neue , sans-serif',
    title: {
      default: {
        size: '36px',
        lineHeight: '44px',
      },
      big: {
        size: '36px',
        lineHeight: '44px',
      },
      subtitle: {
        size: '20px',
        lineHeight: '28px',
      },
    },
    text: {
      small: {
        size: '12px',
        lineHeight: '16px',
      },
      default: {
        size: '16px',
        lineHeight: '24px',
      },
      big: {
        size: '24px',
        lineHeight: '32px',
      },
    },
  },

  // ************* Colors ************* //
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    blackText: 'rgb(71, 69, 64)',
    wrapper: '#e1efea',
    blackOverlay: 'rgba(35, 35, 35, 0.5)',
    yellow: 'rgb(251, 206, 55)',
  },

  // ************* Media ************* //
  media: {
    typography: {
      title: {
        default: {
          size: '24px',
          lineHeight: '32px',
        },
        big: {
          size: '24px',
          lineHeight: '32px',
        },
        subtitle: {
          size: '16px',
          lineHeight: '24px',
        },
      },
    },
  },
};
